import './styles.scss';

type Props = {
  navButtonComponent: React.ReactNode;
};

const AppHeader = ({ navButtonComponent }: Props) => {
  return (
    <header className="portal-header">
      <div className="header-nav-button-component-container">
        {navButtonComponent}
      </div>
      <div className="portal-header-logo-container">
        <img
          src="/images/header-logo.svg"
          className="portal-header-logo"
          alt="header-logo"
        />
        <a
          href="https://isielitetraining.com"
          target="_brank"
          className="portal-header-logo2-button"
        >
          <img
            src="/images/header-logo2.png"
            className="portal-header-logo2"
            alt="header-logo2"
          />
        </a>
      </div>
    </header>
  );
};

export default AppHeader;
